import React from "react";

const Contact = () => {
  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold">Welcome to Contacts Page</h1>
      <p className="text-gray-600 mt-4">
        Discover amazing destinations for your next adventure.
      </p>
    </div>
  );
};

export default Contact;
